export default "__VITE_ASSET__D0K2vLHj__"